import { forwardRef, memo } from 'react';

import { StaticHeader } from '~/components/TableView/StaticHeader';
import TableHeader from '~/components/TableView/TableHeader';
import { dataTestIdMap } from '~/components/TableView/TableHeaders';
import { useTableView } from '~/components/TableView/TableViewContext';
import { makeActiveTableColumnFromOption } from '~/components/TableView/tableColumnWidthsUtils';
import { WORKSPACE_AGENT_ASSET_LIST_TABLE_OPTIONS } from '~/components/v2/components/workspace/workspace-agent-asset-list/workspaceAgentAssetListTableColumns';
import { getVisibilityToggleTypeFromString } from '~/constants/configViews';

export type WorkspaceAgentAssetListTableHeadersProps = {
  horizontalPadding: number;
  topPos: number;
};

const titleColumn = makeActiveTableColumnFromOption('title', false);

const _WorkspaceAgentAssetListTableHeaders = forwardRef<HTMLDivElement, WorkspaceAgentAssetListTableHeadersProps>(
  ({ horizontalPadding, topPos }, ref) => {
    const { getColumnWidthStyle, getTableWidthStyle } = useTableView();

    return (
      <TableHeader
        innerStyle={{
          paddingLeft: horizontalPadding,
          paddingRight: horizontalPadding,
          ...getTableWidthStyle(),
        }}
        ref={ref}
        style={{ top: topPos }}
      >
        <StaticHeader
          className="-ml-4"
          data-testid="NameHeader"
          style={getColumnWidthStyle(titleColumn)}
          title="Name"
        />
        {WORKSPACE_AGENT_ASSET_LIST_TABLE_OPTIONS.map((option) => {
          const optionColumn = makeActiveTableColumnFromOption(option.fieldName, false);
          const toggleType = getVisibilityToggleTypeFromString(option.fieldName);
          const testId = toggleType ? dataTestIdMap[toggleType] : '';

          return (
            <StaticHeader
              data-testid={testId || undefined}
              key={option.fieldName}
              style={getColumnWidthStyle(optionColumn)}
              title={option.label}
            />
          );
        })}
      </TableHeader>
    );
  },
);

_WorkspaceAgentAssetListTableHeaders.displayName = '_WorkspaceAgentAssetListTableHeaders';

export const WorkspaceAgentAssetListTableHeaders = memo(_WorkspaceAgentAssetListTableHeaders);

WorkspaceAgentAssetListTableHeaders.displayName = 'WorkspaceAgentAssetListTableHeaders';
